import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-interbranch-multi',
  templateUrl: './interbranch-multi.component.html',
  styleUrls: ['./interbranch-multi.component.css']
})
export class InterbranchMultiComponent implements OnInit {
    public itemsListMultiInterBranches: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadMultiInterBranches(): Promise<void> {
        this.itemsListMultiInterBranches = await this.datatask.Post(789);
    }

    private async init() {
        this.loadMultiInterBranches();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('interBranchMulti', {
//        templateUrl: 'views/components/views/interBranchMulti/interBranchMulti.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['interBranchMultiService', function (interBranchMultiService) {
//            const vm = this;

//            vm.model = {
//                itemsListMultiInterBranches: []
//            };

//            async function loadMultiInterBranches() {
//                vm.model.itemsListMultiInterBranches = (await interBranchMultiService.listMultiInterBranches());
//            }

//            vm.$onInit = function () {
//                loadMultiInterBranches();
//            };
//        }]
//    });
//})();
